import Vue from 'vue';
import router from '@/router';
import store from '@/store';
import axios from '@/plugins/axios';

//import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'
//Vue.use(BootstrapVue)
//Vue.use(IconsPlugin)

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

Vue.config.productionTip = false;
import App from './App.vue';

Vue.prototype.$axios = axios;

import sanitizeHTML from 'sanitize-html';
Vue.prototype.$sanitize = sanitizeHTML;

require('@/assets/css/style.css')

import VTooltip from 'v-tooltip'
Vue.use(VTooltip, {
  defaultBoundariesElement: "body",
  popover: {
    defaultTrigger: "hover",
    defaultBoundariesElement: "body"
  }
});

import dayjs from "dayjs";
dayjs.locale("ja");
Vue.prototype.$dayjs = dayjs;

import VueGtag from "vue-gtag";
const GA_TRACKING_CODE = process.env.VUE_APP_GA_TRACKING_CODE;
Vue.use(VueGtag, {
  config: {id: GA_TRACKING_CODE}
}, router);

import { toastApi } from '@/components/parts/common/Toast.vue';
const ToastPlugin = (Vue) => {
  let api = toastApi(Vue);
  Vue.$toast = api;
  Vue.prototype.$toast = api;
};
Vue.use(ToastPlugin);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

import Memo from './Memo.vue';
new Vue({
  router,
  store,
  render: h => h(Memo)
}).$mount('#memo');
